import React from 'react';
import ButtonRolesAction from '../ButtonRolesAction/ButtonRolesAction';
import './CreateRoleButtonActions.css';
const CreateRoleButtonActions = ({selectAll, deselectAll}) => {
  return (
    <div className='create-role-button-actions'>
      <ButtonRolesAction
        onClick={selectAll}
        children={'Отметить все'}
        className={'ButtonRolesAction_add'}
      />
      <ButtonRolesAction
        onClick={deselectAll}
        children={'Отменить все'}
        className={'ButtonRolesAction_add'}
      />
    </div>
  );
};

export default CreateRoleButtonActions;
